import React, { useState } from "react";

const ImageWithFallback = ({ src, fallbackSrc, alt, ...props }) => {
  const [currentSrc, setCurrentSrc] = useState(src);

  const handleError = () => {
    setCurrentSrc(fallbackSrc);
  };

  return <img src={currentSrc} alt={alt} onError={handleError} {...props} />;
};

export default ImageWithFallback;
